module.exports = __webpack_public_path__ + "static/media/no3.837f1fc2.jpg";